<template>
  <v-container  fluid class="pa-0">

    <v-row class="pa-0">
    	<v-col cols="12" class="pa-0">
    		<Banner/>
    	</v-col>
    </v-row>
    
    <v-row justify="center" class="pb-0" v-if="promociones.length > 0">
      <v-col cols="12" class="py-0">
        <Promociones/>
      </v-col>
    </v-row>

    <v-row justify="center" class="pa-0">
      <v-col cols="12" >
        <Novedades/>
      </v-col>
    </v-row>


    <v-row justify="center">
      <v-col cols="12">
        <Destacados/>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <MetodosPago/>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
	import Banner      from '@/components/Home/Banner.vue'
  import Novedades   from '@/views/home/Novedades.vue'
  import Destacados  from '@/views/home/Destacados.vue'
  import Promociones from '@/components/Home/Promociones.vue'
  import MetodosPago from '@/views/home/MetodosPago.vue'
	import Buscador    from '@/views/home/Buscador.vue'
// @ is an alias to /src

export default {

  name: 'Home',
  components: {
  	Banner,
  	Novedades,
    Promociones,
    Destacados,
    MetodosPago,
    Buscador
  },

  data(){
    return{
      promociones:[]
    }
  },

  created(){
    this.$http.get('tienda/articulos.promociones.get').then(response=>{
      this.promociones = response.body
      // calular la cantidad de páginas
    }).catch(error=>{console.log(error)})
  },

  methods:{
  	novedades(){
  		this.$router.push({name:'novedades'}).catch(error=>{console.log(error)})
  	},
		destacados(){
			this.$router.push({name:'destacados'}).catch(error=>{console.log(error)})
		},
  }
}
</script>
<style>
  div.v-navigation-drawer__content::-webkit-scrollbar {
    width: 10px;     /* Tamaño del scroll en vertical */
    height: 10px;    /* Tamaño del scroll en horizontal */
  }

  div.v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }

  /* Cambiamos el fondo y agregamos una sombra cuando esté en hover */
  div.v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background: #b3b3b3;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  }

  /* Cambiamos el fondo cuando esté en active */
  div.v-navigation-drawer__content::-webkit-scrollbar-thumb:active {
    background-color: #999999;
  }

  /* Ponemos un color de fondo y redondeamos las esquinas del track */
  div.v-navigation-drawer__content::-webkit-scrollbar-track {
    background: #e1e1e1;
    border-radius: 4px;
  }

  /* Cambiamos el fondo cuando esté en active o hover */
  div.v-navigation-drawer__content::-webkit-scrollbar-track:hover,
  div.v-navigation-drawer__content::-webkit-scrollbar-track:active {
    background: #d4d4d4;
  }

</style>